import React from 'react';

interface Props {
  fillColor: string;
}

const Alarm = ({ fillColor }: Props) => {
  return (
    <svg width='29' height='27' viewBox='0 0 29 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_9187_17137)'>
        <path
          d='M25.8659 6.43527L20.4576 2.09277L18.9409 3.81402L24.3492 8.15652L25.8659 6.43527ZM9.26478 3.81402L7.75986 2.09277L2.35156 6.42402L3.86824 8.14527L9.26478 3.81402ZM14.6966 9.00027H12.933V15.7503L18.5177 18.9565L19.3995 17.5728L14.6966 14.9065V9.00027ZM14.1087 4.50027C8.26542 4.50027 3.52728 9.03402 3.52728 14.6253C3.52728 20.2165 8.25366 24.7503 14.1087 24.7503C19.952 24.7503 24.6902 20.2165 24.6902 14.6253C24.6902 9.03402 19.952 4.50027 14.1087 4.50027ZM14.1087 22.5003C9.55871 22.5003 5.87871 18.979 5.87871 14.6253C5.87871 10.2715 9.55871 6.75027 14.1087 6.75027C18.6588 6.75027 22.3388 10.2715 22.3388 14.6253C22.3388 18.979 18.6588 22.5003 14.1087 22.5003Z'
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_9187_17137'>
          <rect width='28.2172' height='27' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Alarm;
